<template>
  <div class="interface">
    <div class="title">
      <img
        class="title_background"
        src="../../../../static/ningbo/ningbo_log/pay_background.png"
        alt=""
      />
      <div class="title_top">
        <img
          class="title_top_log"
          src="../../../../static/ningbo/ningbo_log/log_pay.png"
          alt=""
        />
        <div class="title_top_text">等待申请人付款</div>
      </div>
      <div class="text">您的图片已提交，请在24小时内完成支付。</div>
    </div>
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <!-- 信息展示 -->
        <div class="infodisplay">
          <div class="infodisplay_goods">
            <div class="infodisplay_name">商品信息</div>
            <div class="infodisplay_money">
              <div class="infodisplay_money01">版面定制服务费：</div>
              <div class="infodisplay_money02">
                ¥{{ orderInfoObj == null ? "" : orderInfoObj.price / 100 }}
              </div>
            </div>
          </div>
          <hr />
          <div class="coupon">
            <div class="coupon_name">优惠券码</div>
            <input
              type="text"
              class="coupon_input"
              placeholder="请输入优惠券码"
            />
          </div>
          <hr />
          <div>
            <div class="infodisplay_goods">
              <div class="infodisplay_name">订单运费</div>
              <div class="infodisplay_money">
                <div class="infodisplay_money01">应付运费：</div>
                <div class="infodisplay_money02">¥{{ freightCharges }}</div>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <div class="infodisplay_goods">
              <div class="infodisplay_name">服务费+订单运费</div>
              <div class="infodisplay_money">
                <div class="infodisplay_money01">应付总额：</div>
                <div class="infodisplay_money02">
                  ¥{{ orderInfoObj == null ? "" : orderInfoObj.price / 100 }}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="order_info">
            <div class="order_name">订单信息</div>
            <div class="order_item">
              <!-- <div class="order_item01">
                订单编号：{{ orderInfoObj == null ? "" : orderInfoObj.orderNo }}
              </div> -->
              <div class="order_item01">
                订单编号：{{ orderInfoObj == null ? "" : orderInfoObj.orderNo }}
              </div>
              <!-- <div class="order_item01">
                下单时间：{{
                  orderInfoObj == null ? "" : orderInfoObj.orderDateTime
                }}
              </div> -->
              <div class="order_item01">
                下单时间：{{
                  orderInfoObj == null ? "" : orderInfoObj.orderDateTime
                }}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <!-- 温馨提示 -->
        <div class="warm_reminder">
          <div class="warm_reminder01">
            <div class="warm_reminder_name">温馨提示：</div>
            <div class="warm_reminder_logo">!</div>
          </div>
          <div class="warm_reminder02">
            <div class="item">{{ hint.hint_item01 }}</div>
            <div class="item">{{ hint.hint_item02 }}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="toPay" @click="wxPay()">微信支付</div>
      </div>
    </div>
    <!-- loading toast -->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">下单中</p>
      </div>
    </div>

    <div v-show="showToast">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <p class="weui-toast__content">{{ toastMsg }}</p>
      </div>
    </div>

    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
      centered
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
  </div>
</template>
<script>
import { generateRandomNumericString } from "@/js/verifyData";
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("@/common/config.js");
export default {
  name: "orderPay_matting_ccb",
  data() {
    return {
      freightCharges: "10",
      orderInfoObj: null,
      appid: "",
      code: "",
      thumbnailSrc: "",
      loading: false,
      showToast: false,
      toastMsg: "",
      targetUrl: "",
      voucherCode: "",
      errorMsg: "",
      faceValue: "",
      practicalAmt: "",
      originalAmt: "",
      hint: {
        hint_info:
          "订单状态：等待申请人付款。您的图片已提交，请在24小时内完成支付，超时订单将自动取消。",
        hint_item01: "1.支付成功后，将无法更改以上卡片定制信息",
        hint_item02: "2.我们将在15个工作日左右为您寄送卡片，请注意查收",
      },
    };
  },
  watch: {
    voucherCode: function (newval, oldval) {
      console.log("newval->", newval);
      console.log("oldval->", oldval);
      if (newval == "") {
        this.faceValue = "";
        this.practicalAmt = "";
        this.originalAmt = "";
      }

      console.log("faceValue->", this.faceValue);
    },
  },
  methods: {
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    toOrderResult: function () {
      this.$router.replace({
        name: "orderResult_ccb",
        params: {
          orderNo: this.orderInfoObj.orderNo,
        },
      });
    },

    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    /* 
    @param voucherValue,优惠券面额
    @orderPrice 订单金额
     */
    caculatePriceWidthVoucher(voucherValue, orderPrice) {
      let price = orderPrice - voucherValue;
      if (price < 0) {
        return 0;
      }
      return price;
    },
    queryVoucher: function () {
      //检查优惠券
      var that = this;
      axios
        .get(config.config_ccb.queryVoucher, {
          params: {
            bankCode: this.orderInfoObj.bankCode,
            voucherCode: this.voucherCode,
            cardTypeId: this.orderInfoObj.cardTypeId,
          },
        })
        .then(function (response) {
          console.log(response);
          var result = response.data;
          //{code: 103, message: "未找到对应的优惠券信息", faceValue: 0, practicalAmt: 0, originalAmt: 0}
          if (result.code == 0) {
            that.faceValue = result.faceValue;
            // that.practicalAmt = result.practicalAmt;
            // that.originalAmt = result.originalAmt;
            let price = that.caculatePriceWidthVoucher(
              result.faceValue,
              that.orderInfoObj.price
            );
            that.unifyOrderWithVoucher(price);
          } else {
            that.errorMsg = result.message;
            that.showErrorMsg();
          }
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },

    wxPay: function () {
      if (this.voucherCode == "") {
        this.unifyOrder();
      } else {
        this.queryVoucher();
      }
    },
    replaceCardface: function () {
      let randomNumericString = generateRandomNumericString(6);
      sessionStorage.setItem("userId", randomNumericString);
      this.$store.commit("ningbo/reuploadImg");
      var param = {
        isModify: 1,
        orderNo: this.orderInfoObj.orderNo,
        backgroundColor: this.orderInfoObj.backgroundColor,
        isPayed: false,
      };

      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.push({
        name: "selectCardface_ccb",
        params: {
          selectParam: selectParam,
        },
      });
    },
    starToPay: function (payargs) {
      console.log("======starToPay======");
      var that = this;
      wx.chooseWXPay({
        timestamp: payargs.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: payargs.nonceStr, // 支付签名随机串，不长于 32 位
        package: payargs.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: payargs.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: payargs.sign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          console.log("支付成功" + res);
          //取消支付成功后通知后台操作
          //that.notifyPayResult("SUCCESS");
          that.toOrderResult();
        },
        // 支付取消回调函数
        cencel: function (res) {
          console.log(res);
        },
        // 支付失败回调函数
        fail: function (res) {
          that.showToastMsg(JSON.stringify(res));
          console.log(res);
        },
      });
    },
    notifyPayResult: function (result) {
      //通知后台，订单支付成功
      //result "SUCCESS" 成功, "FAIL" 失败
      let payResult = {
        orderId: this.orderInfoObj.orderNo,
        ordersStats: result,
      };
      axios
        .post(config.config_ccb.appNotify, payResult)
        .then(function (response) {
          console.log(response);
          //alert(JSON.stringify(response))
        })
        .catch(function (error) {
          console.log(error);
          //alert(JSON.stringify(error))
        });
    },
    adaptIosUrl: function () {
      var url = window.location.href.split("#")[0];
      if (url.indexOf("?") != -1) {
        this.targetUrl = url.split("?")[0];
      } else {
        this.targetUrl = url;
      }
    },
    wxJsSdk: function () {
      var that = this;
      //var url = window.location.href.split('#')[0];
      this.adaptIosUrl();
      var url = this.targetUrl;
      console.log("wxJsSdkUrl:" + url);
      var formData = new FormData();
      formData.append("shareUrl", url);
      formData.append("bankCode", "default");
      formData.append("type", "1");
      axios({
        method: "post",
        url: config.config_ccb.initWXJSSDKConfigInfo,
        data: formData,
      })
        .then(function (response) {
          var result = response.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          let data = result.data;
          that.appid = data.appid;
          console.log(data.appid);
          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);

          /* {
              signature: "1ba9d96ab3b38bb34037b46d5714d61b659d3031",
              appid: "wxecacb5516c17832b",
              jsapi_ticket: "kgt8ON7yVITDhtdwci0qeR5ZO1LunrcgBtLGj8xD8npFwV-6wRlIWdgjZMmuTynPLmFHHz7E30LFBGwzmBtLOg",
              nonceStr: "6024281b-1600-4960-81b6-87876c9203b4",
              timestamp: "1589963929"
            } */

          wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ["chooseWXPay"],
          });

          wx.ready(function () {
            that.checkOpenid();
          });
          wx.error(function (res) {
            console.log(res);
          });
        })
        .catch(function (error) {
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    checkOpenid: function () {
      console.log("=========checkOpenid=========");
      let that = this;

      var openid = sessionStorage.getItem("openid");
      //var code = this.getUrlParam('code') // 截取code
      var code = sessionStorage.getItem("code"); // 从sessionStorage中获取code
      this.code = code;

      console.log("openid:" + openid);
      console.log("code:" + code);

      if (openid == undefined) {
        if (this.code == null || this.code == undefined || this.code == "") {
          //this.getCode();
          this.toGetCodeForOpenId();
        } else {
          sessionStorage.setItem("code", "");
          var myObj = {
            code: this.code,
            bankCode: "default",
            type: "1",
          };
          axios
            .post(config.config_ccb.getJSAPIOpenid, myObj)
            .then(function (response) {
              /* {
                  access_token: "33_ydBrI6lMSAVfEZWX5Q7Kw30jbuTiTCOrca_hPDU3g53tE7drWJRnOteLtPrmtKcFz3gBBL1RhpgefRrBKWQNug"
                  expires_in: 7200
                  openid: "oVdoHv2bVEk5wtyyHAf_Y6cjZZPw"
                  refresh_token: "33_0iS-3XElEHIpcZhmcaaPZl8xTkXnY1O1Zv6NTndAth9ro_srWEeuInDeoNcnR1F70fgCgENZmAcJt1o7YmVi3A"
                  scope: "snsapi_base"
                } */
              console.log(response);
              var result = response.data;
              if (result.code != 0) {
                that.errorMsg = "获取openID失败";
                that.showErrorMsg();
                return;
              }
              let data = result.data;
              var openid = data.openid;
              sessionStorage.setItem("openid", openid);
              //that.$router.go(-1);
              //that.$router.go(0);
            })
            .catch(function (error) {
              console.log(error);
              that.errorMsg = `${error.message}`;
              that.showErrorMsg();
            });
        }
      } else {
      }
    },
    getCode: function () {
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?";
      var appid = "appid=" + encodeURIComponent(this.appid);
      var redirect_uri =
        "&redirect_uri=" + encodeURIComponent(window.location.href);
      var response_type = "&response_type=" + encodeURIComponent("code");
      //静默获取code
      var scope = "&scope=" + encodeURIComponent("snsapi_base");
      //需要用户授权获取code
      //var scope = "&scope=" + encodeURIComponent("snsapi_userinfo");
      var state = "&state=" + encodeURIComponent("123");
      var wechat_redirect = "#wechat_redirect";

      var targetUrl =
        url +
        appid +
        redirect_uri +
        response_type +
        scope +
        state +
        wechat_redirect;

      //window.location.href = targetUrl;
      window.location.replace(targetUrl);
    },

    getUrlParam: function (variable) {
      var query = window.location.search.substring(1);
      console.log("url search param:" + query);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      return "";
    },

    // toGetCodeForOpenId: function () {
    //   //获取openid需要的code
    //   sessionStorage.setItem("appid", this.appid);
    //   this.$router.push({
    //     name: "getCodeForOpenId_matting_ccb",
    //   });
    // },

    unifyOrderWithVoucher: function (discountedPrice) {
      var that = this;
      var openid = sessionStorage.getItem("openid");
      if (openid == undefined) {
        return;
      }
      // var myObj = {
      //   hbTradeType: 1,
      //   openId: openid,
      //   orderNo: this.orderInfoObj.orderNo,
      //   totalFee: discountedPrice,
      //   pay_source: this.orderInfoObj.projectName,
      //   bankCode: this.orderInfoObj.bankCode,
      //   deadline: this.orderInfoObj.deadline, //支付截至日期
      //   voucherCode: this.voucherCode, //电子券
      //   faceValue: this.faceValue,
      //   // practicalAmt: this.practicalAmt,
      //   orderAmt: this.orderInfoObj.price,
      //   appId: this.appid,
      //   payMethod: "wechat",
      // };

      var myObj = {
        hbTradeType: 1,
        openid: openid,
        order_id: this.orderInfoObj.orderNo,
        total_fee: discountedPrice,
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.orderInfoObj.price,
        appid: this.appid,
      };

      console.log(JSON.stringify(myObj));
      that.showLoading();

      axios
        .post(config.config_ccb.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            console.log(payargs);
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              if (that.orderInfoObj.price == 0) {
                //0元，无需支付，直接跳转到订单结果页面
                that.toOrderResult();
              } else {
                that.starToPay(payargs);
              }
            }
          } else {
            that.errorMsg = "unifiedOrder：" + data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },

    unifyOrder: function () {
      var that = this;
      var openid = sessionStorage.getItem("openid");
      if (openid == undefined) {
        return;
      }
      // var myObj = {
      //   hbTradeType: 1,
      //   openId: openid,
      //   orderNo: this.orderInfoObj.orderNo,
      //   totalFee: this.orderInfoObj.price,
      //   pay_source: this.orderInfoObj.projectName,
      //   bankCode: this.orderInfoObj.bankCode,
      //   deadline: this.orderInfoObj.deadline, //支付截至日期
      //   voucherCode: this.voucherCode, //电子券
      //   faceValue: this.faceValue,
      //   // practicalAmt: this.practicalAmt,
      //   orderAmt: this.orderInfoObj.price,
      //   appId: this.appid,
      //   payMethod: "wechat",
      // };

      var myObj = {
        hbTradeType: 1,
        openid: openid,
        order_id: this.orderInfoObj.orderNo,
        total_fee: this.orderInfoObj.price, //支付金额
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.orderInfoObj.price, //订单金额
        appid: this.appid,
      };

      console.log(JSON.stringify(myObj));
      that.showLoading();

      axios
        .post(config.config_ccb.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            console.log(payargs);
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              that.starToPay(payargs);
            }
          } else {
            that.errorMsg = data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    toGetCodeForOpenId: function () {
      //获取openid需要的code
      sessionStorage.setItem("appid", this.appid);
      this.$router.push({
        name: "getCodeForOpenId_matting_ccb",
      });
    },
  },
  mounted: function () {
    /* {
         orderNo: '01248790113566597120',
         orderDateTime: '2020-05-22 09:39:22',
         price: 1,
         projectName: 'DIY',
         thumbnailFileUrl: ''
       } */
    var orderInfo = this.$route.params.orderInfo;
    if (orderInfo !== undefined) {
      this.orderInfoObj = JSON.parse(orderInfo);
      sessionStorage.setItem("orderInfo", orderInfo);
    } else {
      var orderInSession = sessionStorage.getItem("orderInfo");
      this.orderInfoObj = JSON.parse(orderInSession);
    }

    this.wxJsSdk();
  },
};
</script>

<style scoped>
.title {
  width: 100%;
}
.title_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 50%;
  position: absolute;
  top: 2rem;
  left: 25%;
}
.title_top_log {
  width: 2rem;
  height: 2rem;
}
.title_top_text {
  font-size: 1.2rem;
  font-weight: 700;
}
.title_background {
  width: 100%;
}
.text {
  width: 70%;
  font-size: 0.8rem;
  color: #92969b;
  position: absolute;
  top: 4rem;
  left: 20%;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  position: absolute;
  top: 6rem;
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
  padding-top: 1.8rem;
} */
.header_hint {
  width: 100%;
  background-color: #f9ecd0;
  color: #a66e36;
  font-weight: 500;
  font-size: 0.8rem;
  padding: 1.8rem 1rem 0;
}
.infodisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.infodisplay_goods {
  width: 100%;
  height: 4rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.infodisplay_name {
  font-size: 1rem;
  font-weight: 700;
}
.infodisplay_money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.infodisplay_money01 {
  font-size: 0.8rem;
  font-weight: 500;
}
.infodisplay_money02 {
  font-size: 0.8rem;
  font-weight: 700;
}
.coupon {
  width: 100%;
  height: 3rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.coupon_name {
  font-size: 1rem;
  font-weight: 700;
}
.coupon_input {
  width: 8rem;
  height: 2rem;
  border: white solid 0;
}
.order_info {
  width: 100%;
  height: 4rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.order_name {
  font-size: 1rem;
  font-weight: 700;
}
.order_item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.order_item01 {
  font-size: 0.6rem;
}
.freightCharges_arr {
  margin-left: 14rem;
}
.freightCharges {
  font-size: 0.8rem;
  color: red;
}
.warm_reminder {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.warm_reminder01 {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start; /* 显式声明靠左 */
}
.warm_reminder_name {
  width: 100%;
  font-size: 0.8rem;
  font-weight: 500;
  padding-bottom: 0.5rem;
  margin-right: 1rem;
}
.warm_reminder_logo {
  width: 1rem;
  height: 1rem;
  border: #dcb884 solid 1px;
  color: white;
  border-radius: 50%;
  text-align: center;
  background-color: #dcb884;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 900;
}
.warm_reminder02 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item {
  width: 100%;
  font-size: 0.8rem;
  font-weight: 500;
  padding-bottom: 0.2rem;
}
.main {
  /* background-color: yellow;
  height: 3rem; */
  width: 100%;
}
/* .footer {
  background-color: blue;
  height: 3rem;
} */
.toPay {
  width: 80%;
  height: 2.8rem;
  border-radius: 1.4rem;
  background: linear-gradient(to right, #093695, #0d1632);
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  margin: 0 auto;
  margin-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CCB_demo/Matting/OrderPay_ningbo.vue